module.exports = __webpack_public_path__ + "static/media/LogicWedge2_4_drag_3.61b67690.png";